import moment from 'moment';
import Constants from '../utils/Constants';
import {
    ADD_CORRELATION,
    CLEAN_CORRELATIONS,
    REMOVE_CORRELATION,
} from '../actions/correlations';

export const cleanCorrelations = (oldState, cleaningDateTime) => {
    const dateTimeToCompare = moment(cleaningDateTime).subtract(Constants.CORRELATIONS_CLEANUP_IN_MINS, 'minutes');
    return oldState.filter((correlation) => dateTimeToCompare.isBefore(moment(correlation.creationDateTime)));
};

const correlations = (state = [], action = undefined) => {
    switch (action.type) {
        case ADD_CORRELATION:
            return [...state, action.payload];
        case CLEAN_CORRELATIONS:
            return cleanCorrelations(state, action.payload);
        case REMOVE_CORRELATION:
            return state.filter((correlation) => correlation.id !== action.payload);
        default:
            return state;
    }
};

export default correlations;
